import { render, staticRenderFns } from "./WorkflowFormListPage.vue?vue&type=template&id=956598dc&"
import script from "./WorkflowFormListPage.vue?vue&type=script&lang=ts&"
export * from "./WorkflowFormListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports